webpackJsonp([1],{

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierLedger_vue__ = __webpack_require__(734);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbe8800_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierLedger_vue__ = __webpack_require__(741);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dbe8800"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierLedger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbe8800_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierLedger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(74);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      supplier: {},
      transactions: [],
      totalPurchases: 0,
      totalPayments: 0,
      balance: 0,
      supplierId: this.$route.params.id

    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var supplierId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              supplierId = _this.$route.params.id;

              _this.supplierId = supplierId;
              console.log(_this.supplier);
              _context.next = 5;
              return _this.fetchSupplier();

            case 5:
              _context.next = 7;
              return _this.listenToTransactions();

            case 7:
              _this.calculateTotals();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    '$route.params.id': function $routeParamsId(newId, oldId) {
      // console.log('🔄 تغير المورد من', oldId, 'إلى', newId);
      this.supplierId = newId;
      this.fetchSupplier();
      this.listenToTransactions(); // أو fetchTransactions حسب طريقتك
    }
  },
  methods: {
    fetchSupplier: function fetchSupplier() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore().collection('Dealers').doc(_this2.supplierId).get();

              case 2:
                doc = _context2.sent;

                _this2.supplier = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: doc.id }, doc.data());

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    listenToTransactions: function listenToTransactions() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore().collection('Dealers').doc(this.supplierId).collection('transactions').orderBy('date', 'desc').onSnapshot(function (snapshot) {
        _this3.transactions = snapshot.docs.map(function (doc) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: doc.id }, doc.data());
        });
        _this3.calculateTotals();
      });
    },
    calculateTotals: function calculateTotals() {
      this.totalPurchases = this.transactions.filter(function (t) {
        return t.type === 'purchase';
      }).reduce(function (sum, t) {
        return sum + (t.totalAmount || 0);
      }, 0);

      this.totalPayments = this.transactions.filter(function (t) {
        return t.type === 'payment';
      }).reduce(function (sum, t) {
        return sum + (t.totalAmount || 0);
      }, 0);

      this.balance = this.totalPurchases - this.totalPayments;
    },
    formatDate: function formatDate(ts) {
      if (!ts) return '';
      var date = ts.toDate();
      return date.toLocaleDateString();
    }
  }
});

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(729)("d427d844", content, true, {});

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(728)(true);
// imports


// module
exports.push([module.i, ".ledger-page[data-v-1dbe8800]{padding:1rem}.ledger-table[data-v-1dbe8800]{width:100%;border-collapse:collapse}.ledger-table td[data-v-1dbe8800],.ledger-table th[data-v-1dbe8800]{padding:10px;border:1px solid #ccc;text-align:center}.ledger-summary[data-v-1dbe8800]{margin-top:20px;text-align:right;font-weight:700}.head[data-v-1dbe8800]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.head .title[data-v-1dbe8800]{font-size:20px;color:#707070}.head .supplier-name[data-v-1dbe8800]{font-size:25px;font-weight:500}", "", {"version":3,"sources":["D:/Projects/‏‏greenhousecakesTest/src/pages/SupplierLedger.vue"],"names":[],"mappings":"AACA,8BACI,YAAa,CAChB,AACD,+BACE,WAAY,AACZ,wBAA0B,CAC3B,AACD,oEACE,aAAc,AACd,sBAAuB,AACvB,iBAAmB,CACpB,AACD,iCACE,gBAAiB,AACjB,iBAAkB,AAClB,eAAkB,CACnB,AACD,uBACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,8BACI,eAAgB,AAChB,aAAe,CAClB,AACD,sCACI,eAAgB,AAChB,eAAiB,CACpB","file":"SupplierLedger.vue","sourcesContent":["\n.ledger-page[data-v-1dbe8800]{\n    padding: 1rem\n}\n.ledger-table[data-v-1dbe8800] {\n  width: 100%;\n  border-collapse: collapse;\n}\n.ledger-table th[data-v-1dbe8800], .ledger-table td[data-v-1dbe8800] {\n  padding: 10px;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n.ledger-summary[data-v-1dbe8800] {\n  margin-top: 20px;\n  text-align: right;\n  font-weight: bold;\n}\n.head[data-v-1dbe8800]{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.head .title[data-v-1dbe8800]{\n    font-size: 20px;\n    color: #707070;\n}\n.head .supplier-name[data-v-1dbe8800]{\n    font-size: 25px;\n    font-weight: 500;\n}\n    "],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ledger-page"},[_c('div',{staticClass:"head"},[_c('span',{staticClass:"title"},[_vm._v("כרטסת")]),_vm._v(" "),_c('span',{staticClass:"supplier-name"},[_vm._v(_vm._s(_vm.supplier.selectDealerName))])]),_vm._v(" "),_c('div',{staticClass:"ledger-controls"}),_vm._v(" "),_c('table',{staticClass:"ledger-table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(tx){return _c('tr',{key:tx.id},[_c('td',[_vm._v(_vm._s(_vm.formatDate(tx.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.quantity || '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.unitPrice || '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.totalAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.paymentMethod))]),_vm._v(" "),_c('td',[(tx.attachmentURL)?_c('a',{attrs:{"href":tx.attachmentURL,"target":"_blank"}},[_vm._v("📎")]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{staticClass:"ledger-summary"},[_c('p',[_vm._v("📌 مجموع المشتريات: ₪ "+_vm._s(_vm.totalPurchases))]),_vm._v(" "),_c('p',[_vm._v("💸 مجموع الدفعات: ₪ "+_vm._s(_vm.totalPayments))]),_vm._v(" "),_c('p',[_vm._v("📊 الرصيد النهائي: ₪ "+_vm._s(_vm.balance))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("التاريخ")]),_vm._v(" "),_c('th',[_vm._v("النوع")]),_vm._v(" "),_c('th',[_vm._v("الوصف")]),_vm._v(" "),_c('th',[_vm._v("الكمية")]),_vm._v(" "),_c('th',[_vm._v("السعر")]),_vm._v(" "),_c('th',[_vm._v("المبلغ")]),_vm._v(" "),_c('th',[_vm._v("طريقة الدفع")]),_vm._v(" "),_c('th',[_vm._v("مرفق")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.dc71e130743b0e2f1315.js